import { NavLink } from 'react-router-dom'

import AutoDeploymentIcon from '@/assets/icons/auto-deployment.svg?react'
import AutoscalingIcon from '@/assets/icons/auto-scaling.svg?react'
import BillingIcon from '@/assets/icons/billing.svg?react'
import CreateNewIcon from '@/assets/icons/create-new.svg?react'
import CustomImageIcon from '@/assets/icons/custom-image.svg?react'
import DataListIcon from '@/assets/icons/data-list.svg?react'
import InstanceListIcon from '@/assets/icons/instance-list.svg?react'
import MeshClusteringIcon from '@/assets/icons/mesh-clustering.svg?react'
import ModelRouteIcon from '@/assets/icons/model-route.svg?react'
import NetworkEndpointIcon from '@/assets/icons/network-endpoint.svg?react'
import PlatformSettingIcon from '@/assets/icons/platform-setting.svg?react'
import PrivateRegionIcon from '@/assets/icons/private-region.svg?react'
import SnapListIcon from '@/assets/icons/snapshot-list.svg?react'
import SpaceMgrIcon from '@/assets/icons/space-mgr.svg?react'
import { cn } from '@/utils/style'

import { Trans } from './Trans'

export function Menu() {
  return (
    <aside
      className="card p-4 bg-panel-white w-[240px] flex flex-shrink-0 flex-col justify-between gap-10 sticky top-0 overflow-y-auto"
      data-ai-component="sidebar"
    >
      <nav aria-label="Main Navigation">
        <div>
          <NavLink
            to="/create"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-create"
            data-ai-value="/create"
          >
            <CreateNewIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuCreateNew">Create New</Trans>
          </NavLink>
          <NavLink
            to="/instances"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-my-instances"
            data-ai-value="/instances"
          >
            <InstanceListIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuMyInstance">My Instances</Trans>
          </NavLink>
          <NavLink
            to="/model-route"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-model-route"
            data-ai-value="/model-route"
          >
            <ModelRouteIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuModelRoute">Model Route</Trans>
          </NavLink>
          <NavLink
            to="/deploy"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-auto-deploy"
            data-ai-value="/deploy"
          >
            <AutoDeploymentIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuAutoDeployment">Auto Deploy</Trans>
          </NavLink>
          <NavLink
            to="/data"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-datadrive"
            data-ai-value="/data"
          >
            <DataListIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuDataMgr">Datadrive</Trans>
          </NavLink>
          <NavLink
            to="/scaling"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-auto-scaling"
            data-ai-value="/scaling"
          >
            <AutoscalingIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuAutoScaling">Autoscaling</Trans>
          </NavLink>
          <NavLink
            to="/image"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-images"
            data-ai-value="/image"
          >
            <CustomImageIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuCustomImages">Images</Trans>
          </NavLink>
          <NavLink
            to="/snapshots"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-snapshots"
            data-ai-value="/snapshots"
          >
            <SnapListIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuSnapshots">Snapshots</Trans>
          </NavLink>
          <NavLink
            to="/mesh"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-mesh-clustering"
            data-ai-value="/mesh"
          >
            <MeshClusteringIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuMeshClustering">Mesh Clustering</Trans>
          </NavLink>
          <NavLink
            to="/space"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-storage-space"
            data-ai-value="/space"
          >
            <SpaceMgrIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuSpace">Storage Space</Trans>
          </NavLink>
          <NavLink
            to="/eip"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-network-endpoint"
            data-ai-value="/eip"
          >
            <NetworkEndpointIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuNetworkEndpoint">Network Endpoint</Trans>
          </NavLink>
          <div>
            <div className="h-px bg-neutral-200 m-4" />
            <NavLink
              to="/private-region"
              className={({ isActive }) => cn('menu-link', { active: isActive })}
              data-ai-component="nav-link"
              data-ai-action="go-to-private-region"
              data-ai-value="/private-region"
            >
              <PrivateRegionIcon className="w-5 h-5 text-tertiary" />
              <Trans i18nKey="layout.menuPrivateRegion">Private Region</Trans>
            </NavLink>
          </div>
        </div>
        <div className="h-px bg-neutral-200 m-4" />
        <div className="mt-4">
          <NavLink
            to="/billing"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-billing"
            data-ai-value="/billing"
          >
            <BillingIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuBilling">Platform Billing</Trans>
          </NavLink>

          <NavLink
            to="/profile"
            className={({ isActive }) => cn('menu-link', { active: isActive })}
            data-ai-component="nav-link"
            data-ai-action="go-to-profile"
            data-ai-value="/profile"
          >
            <PlatformSettingIcon className="w-5 h-5 text-tertiary" />
            <Trans i18nKey="layout.menuProfile">Platform Setting</Trans>
          </NavLink>
        </div>
      </nav>
    </aside>
  )
}
